// MUI Components
import {
  Box,
  Typography,
  Chip
} from '@mui/material';

// lucide Icons
import {
  Gamepad2,
  Trophy
} from 'lucide-react';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';

export default function GameStatusHeader({ score, currentIndex, totalProducts }) {
  const { theme } = useTheme();

  return (
    <Box mb={3} display="flex" justifyContent="space-between" alignItems="center" mt={1}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Gamepad2 size={20} style={{ marginRight: '10px', color: theme.color.primary }} />
          <Typography variant="h5" color={theme.color.primary} fontWeight={700} sx={{ fontSize: '1.5rem', fontFamily: theme.fontFamily }}>
            Add Missing Info to Your Reports
          </Typography>
        </Box>
      </Box>
      <Box textAlign="right">
        <Typography variant="h6" color={theme.accent.success} fontWeight={700} sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          mb: 0.5,
          fontFamily: theme.fontFamily
        }}>
          <Trophy size={18} style={{ marginRight: '6px', color: theme.accent.success }} />
          Score: <span style={{ marginLeft: '4px' }}>{score}</span>
        </Typography>
        <Chip
          size="small"
          label={`Product ${currentIndex + 1} of ${totalProducts}`}
          sx={{
            fontWeight: 600,
            bgcolor: `${theme.color.secondary}22`,
            color: theme.text.primary,
            fontFamily: theme.fontFamily
          }}
        />
      </Box>
    </Box>
  );
}
